module.exports = __webpack_public_path__ + "img/30.8244d044.jpg";